import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from "../../utils/gqlMfaClient";
import { getClientId } from "../../utils/config";
import { wrapQuery } from "../../utils/wrapQuery";
export { mfaStatus };
var mfaStatusQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query MfaStatus($mfaToken: String!, $userUuid: String!, $clientId: NonEmptyString!) {\n    mfaStatus(mfaToken: $mfaToken, userUuid: $userUuid, clientId: $clientId) {\n      otpToken\n      status\n    }\n  }\n"])));
async function mfaStatus(mfaToken, userUuid) {
  var data = await wrapQuery('mfaStatus', mfaStatusQuery, {
    mfaToken: mfaToken,
    userUuid: userUuid,
    clientId: getClientId()
  });
  return data.mfaStatus;
}